"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var modal_1 = require("./components/modal");
var modal_header_1 = require("./components/modal-header");
var modal_body_1 = require("./components/modal-body");
var modal_footer_1 = require("./components/modal-footer");
var autofocus_1 = require("./directives/autofocus");
__export(require("./components/modal"));
__export(require("./components/modal-header"));
__export(require("./components/modal-body"));
__export(require("./components/modal-footer"));
__export(require("./components/modal-instance"));
var Ng2Bs3ModalModule = /** @class */ (function () {
    function Ng2Bs3ModalModule() {
    }
    Ng2Bs3ModalModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule
            ],
            declarations: [
                modal_1.ModalComponent,
                modal_header_1.ModalHeaderComponent,
                modal_body_1.ModalBodyComponent,
                modal_footer_1.ModalFooterComponent,
                autofocus_1.AutofocusDirective
            ],
            exports: [
                modal_1.ModalComponent,
                modal_header_1.ModalHeaderComponent,
                modal_body_1.ModalBodyComponent,
                modal_footer_1.ModalFooterComponent,
                autofocus_1.AutofocusDirective
            ]
        })
    ], Ng2Bs3ModalModule);
    return Ng2Bs3ModalModule;
}());
exports.Ng2Bs3ModalModule = Ng2Bs3ModalModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmcyLWJzMy1tb2RhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9uZzItYnMzLW1vZGFsL25nMi1iczMtbW9kYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxzQ0FBeUM7QUFDekMsMENBQStDO0FBRS9DLDRDQUFvRDtBQUNwRCwwREFBaUU7QUFDakUsc0RBQTZEO0FBQzdELDBEQUFpRTtBQUNqRSxvREFBNEQ7QUFFNUQsd0NBQW1DO0FBQ25DLCtDQUEwQztBQUMxQyw2Q0FBd0M7QUFDeEMsK0NBQTBDO0FBQzFDLGlEQUE0QztBQXFCNUM7SUFBQTtJQUNBLENBQUM7SUFEWSxpQkFBaUI7UUFuQjdCLGVBQVEsQ0FBQztZQUNOLE9BQU8sRUFBRTtnQkFDTCxxQkFBWTthQUNmO1lBQ0QsWUFBWSxFQUFFO2dCQUNWLHNCQUFjO2dCQUNkLG1DQUFvQjtnQkFDcEIsK0JBQWtCO2dCQUNsQixtQ0FBb0I7Z0JBQ3BCLDhCQUFrQjthQUNyQjtZQUNELE9BQU8sRUFBRTtnQkFDTCxzQkFBYztnQkFDZCxtQ0FBb0I7Z0JBQ3BCLCtCQUFrQjtnQkFDbEIsbUNBQW9CO2dCQUNwQiw4QkFBa0I7YUFDckI7U0FDSixDQUFDO09BQ1csaUJBQWlCLENBQzdCO0lBQUQsd0JBQUM7Q0FBQSxBQURELElBQ0M7QUFEWSw4Q0FBaUIifQ==


// WEBPACK FOOTER //
// src/ng2-bs3-modal/ng2-bs3-modal.ts